import { render } from "./DeleteShieldButton.vue?vue&type=template&id=f1326f86&lang=true"
import script from "./DeleteShieldButton.vue?vue&type=script&lang=js"
export * from "./DeleteShieldButton.vue?vue&type=script&lang=js"

import "./DeleteShieldButton.vue?vue&type=style&index=0&id=f1326f86&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__